<template>

<otif-modal ref="add-ecm-folder" v-bind:title="ecmResourceStrings.ttlAddExcludedFolder" :value="value" @input="$emit('input', $event)" @shown="onShown">
<b-form>
    <otif-textInput
        v-model="$v.form.description.$model"
        v-bind:label="ecmResourceStrings.lblCreateFolder"
        required
        :validation="$v.form.description"
        v-bind:invalidMessage="ecmResourceStrings.msgECMFolderValueRequired"
        ref="first_input" />
</b-form>
<template slot="footer">
    <otif-button className=" OTPrimary" @click.native="createEcmExcludedFolder" :disabled="$v.$invalid" >{{ecmResourceStrings.lblSave}}</otif-button>
    <otif-button className=" OTSecondary" @click.native="cancel">{{ecmResourceStrings.lblCancel}}</otif-button>
</template>
</otif-modal>

</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
    components: {
        
    },
    props: ['value', 'existingNames'],
    mixins: [
        validationMixin
    ],
    data() {
        return {
            
            ecmResourceStrings: require('../../utils/resourceECM.js'),

            form: {
                description: '',
            }
        }
    },
    computed: {
   
    },
    validations: {     
        form:{
            description: { required, isUnique(value) {
              if (value === '') return true;
              const result = this.existingNames.find((el) => {if (el.description === value)
                    {
                        return true;
                    }
                    else
                    {
                        return false;
                    }
                });
                if(result == undefined)
                {
                    //not found
                    return true;
                }
                else
                {
                    return false;
                }
            }}
        }
    },

    methods: {
        onShown() {
            this.form.description = '';
            this.$refs.first_input.focus();
        },

        cancel() {
            this.$emit('input', false);
        },

        createEcmExcludedFolder() {
            this.$parent.createEcmExcludedFolder(this.form.description);
            this.$emit('input', false);
        },
    },
}

</script>
